import { Country, Filters, Option } from '@utils/pageConfig/Types';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { ProductType } from '@pages/product-analyzer/Product';

export class Currency {
  currencyCode = '';
  currencyName = '';
}

export class Amount {
  value = 0;
  percentage = 0;
}

export class Performance {
  revenue = new Amount();
  growth = new Amount();
  ytd = new Amount();
  mat = new Amount();
}

export class Percentage {
  sharePercentage = 0;
  growthPercentage = 0;
}

export class Revenue {
  selectedPeriod = new Percentage();
  ytd = new Percentage();
  mat = new Percentage();
}

export class SalesPerformance {
  currency = new Currency();
  marketPerformance = new Performance();
  myPerformance = new Performance();
  myRevenueShare = new Revenue();
  myRevenueGrowthVsMarket = new Revenue();
}

export interface PerformanceParam {
  clientId: number;
  productType: ProductType;
  productGroup: Option[] | undefined;
  countries: Country[];
  period: string;
  comparisonPeriod: string;
  periodType: Periodicity;
  saleType: string;
  appliedFilters: Filters[];
  isSummary: boolean;
}
